import { render, staticRenderFns } from "./Swapper.vue?vue&type=template&id=b71a13c4&scoped=true&"
import script from "./Swapper.vue?vue&type=script&lang=js&"
export * from "./Swapper.vue?vue&type=script&lang=js&"
import style0 from "./Swapper.vue?vue&type=style&index=0&id=b71a13c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71a13c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b71a13c4')) {
      api.createRecord('b71a13c4', component.options)
    } else {
      api.reload('b71a13c4', component.options)
    }
    module.hot.accept("./Swapper.vue?vue&type=template&id=b71a13c4&scoped=true&", function () {
      api.rerender('b71a13c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/Swapper.vue"
export default component.exports